import { cn } from "./cn";

/**
 * The action row for every overlay footer. Callers pass buttons in reading
 * order; this container owns their sizing on both sides of the 768px cut, so
 * a footer button must not pass `fullWidth`. Below 768px, `align-items:
 * stretch` already makes each button full width. At 768px and up they sit at
 * content width in a right-aligned row.
 *
 * `md:flex-wrap` is the overflow guard: a child that still insists on
 * `w-full` wraps onto its own full-width line inside the surface instead of
 * pushing a sibling off the left edge. That wrapped fallback is a safety net,
 * not an approved layout, because it puts the non-destructive button above
 * the destructive one and reverses the stacked order in
 * `destructive-confirmation.mdc`. ISSUE-658.
 */
export const OVERLAY_FOOTER_LAYOUT = cn(
  "flex flex-col-reverse gap-2",
  "md:flex-row md:flex-wrap md:justify-end",
);
